frappe.provide("frappe.ui");

const default_statuses = {
	0: "Draft",
	1: "Submitted",
	2: "Cancelled",
};

frappe.ui.document_timeline = class DocumentTimeline {
	constructor(opts) {
		Object.assign(this, opts);
		this.wrapper = null;
		this.make();
		this.bind_to_frm();
	}

	bind_to_frm() {
		$(this.frm.wrapper).off("render_complete.document_timeline");
		$(this.frm.wrapper).on("render_complete.document_timeline", () => {
			this.make();
		});
	}

	async get_data() {
		this.data = await frappe.call({
			method: "frappe.utils.document_timeline.get_document_timeline",
			args: {
				document: this.frm.doc,
				configuration: this.config,
			},
		});
	}

	async make() {
		this.wrapper = $(this.frm.sidebar.sidebar).find(".dodock-document-timeline").get(0);
		if (!this.wrapper) return;

		const current_docname = this.frm.doc?.name;
		if (!current_docname) return;

		if (this.loading_docname === current_docname) {
			return;
		}

		try {
			this.loading_docname = current_docname;
			await this.get_data();

			if (this.frm.doc?.name !== current_docname) return;

			const content = this.data.message.map(async (doc) => {
				await frappe.model.with_doctype(doc.doctype);
				const linked_doc = await frappe.model.with_doc(doc.doctype, doc.docname);
				const status = __(
					doc.data.workflow_state ||
						doc.data.status ||
						default_statuses[doc.data.docstatus]
				);
				const indicator = frappe.get_indicator(
					linked_doc,
					doc.doctype,
					doc.data.workflow_state
				);

				return this.timeline_model(doc, status, indicator[1], this.is_current_doc(doc));
			});

			const resolved_content = await Promise.all(content);

			if (this.frm.doc?.name !== current_docname) return;

			const timeline = document.createElement("div");
			timeline.classList.add("new-timeline");
			timeline.innerHTML = `<h6 class="timeline-title">${__("Linked Transactions")}</h6>`;

			const timeline_items = document.createElement("div");
			timeline_items.classList.add("timeline-items");

			timeline.append(timeline_items);

			timeline_items.innerHTML = resolved_content.join("");

			this.wrapper.innerHTML = "";
			this.wrapper.append(timeline);
		} finally {
			if (this.loading_docname === current_docname) {
				this.loading_docname = null;
			}
		}
	}

	timeline_model(doc, status, color, current = false) {
		const timestamp = frappe.datetime.str_to_user(doc.date);
		const component_wrapper_start = current
			? "<div>"
			: `<a href="${frappe.utils.get_form_link(doc.doctype, doc.docname, false)}">`;
		const component_wrapper = current ? "</div>" : "</a>";

		const image_html = doc.image
			? `<div class="timeline-item-image">
				<img src="${encodeURI(doc.image)}" alt="" loading="lazy">
			</div>`
			: "";
		const title_html = frappe.utils.escape_html(doc.title);

		return `<div class="timeline-item ${current ? "is-current" : ""}">
				${component_wrapper_start}
					<div class="timeline-content frappe-card">
						<div class="timeline-item-inner ${doc.image ? "has-image" : ""}">
							${image_html}
							<div class="timeline-item-details">
								<div class="timeline-item-header">
									<div class="text-muted small">${__(doc.doctype)}</div>
									<div class="text-muted small">${timestamp}</div>
								</div>
								<div class="timeline-item-title">${title_html}</div>
								<div class="timeline-item-body">
									<div class="d-flex align-items-center justify-content-between">
										<span class="indicator-pill no-indicator-dot whitespace-nowrap ${color}">
											<span>${status}</span>
										</span>
										<div class="timeline-item-amount font-weight-bold">
											${doc.amount ? format_currency(doc.amount, doc.currency) : ""}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				${component_wrapper}
			</div>`;
	}

	is_current_doc(doc) {
		if (doc.doctype == this.frm.doctype && doc.docname == this.frm.doc.name) {
			return true;
		}

		return false;
	}
};

const _get_form_sidebar_extension = frappe.get_form_sidebar_extension;
frappe.get_form_sidebar_extension = () => {
	const ext = _get_form_sidebar_extension?.() || "";
	return `<div class="dodock-document-timeline"></div>${ext}`;
};

$(document).on("form-refresh", (_event, frm) => {
	frappe.provide("frappe.ui.document_timeline_settings");

	if (frappe.ui.document_timeline_settings[frm.doctype]) {
		if (!frm.document_timeline) {
			frm.document_timeline = new frappe.ui.document_timeline({
				frm: frm,
				config: frappe.ui.document_timeline_settings[frm.doctype],
			});
		} else {
			frm.document_timeline.config = frappe.ui.document_timeline_settings[frm.doctype];
			frm.document_timeline.make();
		}
	}
});
